import { Select } from "antd";
import DownIcon from "assets/icons/down-blue.svg";
import clsx from "clsx";
import "./style.scss";
interface IProps {
  data: any;
  label?: string;
  placeholder?: string;
  isArrow: boolean;
  setIsArrow: (isArrow: boolean) => void;
  value: string;
  setValue: (value: string) => void;
  onChange?: (e: any) => void;
  style?: React.CSSProperties;
  styleSpecs?: number;
  defaultValue?: string;
  labelClassName? :string,

}

const SelectComponent = ({
  data,
  label,
  isArrow,
  setIsArrow,
  value,
  setValue,
  placeholder,
  onChange,
  style,
  styleSpecs,
  defaultValue,
  labelClassName,
}: IProps) => {
  const toggleStyle = clsx({
    ["selectInput selectInputOpen"]: isArrow === true,
    ["selectInput"]: isArrow === false,
  });

  return (
    <div className={toggleStyle}>
      <label className={"selectInput__label " + (labelClassName ? labelClassName : '')}>{label}</label>
      <Select
        value={value}
        dropdownClassName="selectInput__dropdown"
        placeholder={placeholder}
        open={isArrow}
        // defaultValue={defaultValue}
        dropdownAlign={{
          offset: [0, 0],
        }}
        suffixIcon={<img src={DownIcon} />}
        bordered={false}
        style={{ ...style }}
        onDropdownVisibleChange={() => setIsArrow(!isArrow)}
        onChange={(value: string) => setValue(value)}
      >
        {data?.map((item: any, index: number) => (
          <Select.Option key={index} value={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default SelectComponent;